import './index.scss'

import { useLocation } from 'react-router'
import { Button, Drawer, Input, Layout } from 'antd'

import couponSrc from '@/home/src/assets/imgs/noCoupon.png'
import { Props, useCoupon } from '@api/home/shopCart/useCoupon'
import { Container, Flex, Icon, Switch } from '@ui-pc'
import { Type } from '@utils/tool'

import { ShopEmty as Empty } from '../CartList/ShopEmty'
import CouponItem from './CouponItem'
import CouponReg from './CouponReg'
import { routesPath } from '@api/home/utils'

const { Content } = Layout

export const CouponInput = (props: { loading; onChange; onApply }) => {
  const { onChange, loading, onApply } = props
  return (
    <Container isLoading={loading}>
      <Flex
        alignItems="center"
        warp={false}
        colGap={8}
        className="coupon-input-box">
        <Input placeholder="Coupon Code" onChange={onChange} />
        <Button className="coupon-apply" onClick={onApply}>
          Apply
        </Button>
      </Flex>
    </Container>
  )
}

const Index = (props: Props & ReturnType<typeof useCoupon>) => {
  const {
    isLogin,
    value,
    open,
    data,
    onApply,
    removeCoupon,
    currentCoupon,
    isLoading,
    selectCoupon,
    currentCode,
    readonly,
    onInputChange,
    usingCoupon,
    finishGrantCoupons,
    setOpen,
    couponInfo,
    showSubscribe
  } = props
  const { subscribeCoupon, subscribeStatus } = couponInfo
  const location = useLocation()

  return (
    <Drawer
      title={readonly ? 'Featured Coupons' : 'Coupons'}
      placement="right"
      closeIcon={<i className="iconfont icon-close common-drawer-close"></i>}
      className="coupons"
      width={480}
      onClose={() => setOpen(false)}
      open={open}
      children={
        <Container isLoading={isLoading}>
          <Layout style={{ background: '#fff' }}>
            <Switch either={readonly}>
              {/* 详情页展示 */}
              <div>
                {JSON.stringify(selectCoupon) !== '{}' ? (
                  <>
                    <div className="after-price-sku">
                      <div className="com-price-box after-box">
                        <p className="after-price">
                          {selectCoupon?.afterCouponPrice}
                        </p>
                        <p className="price-text">Price After Coupon</p>
                      </div>
                    </div>
                    <div className="after-price-bottom">
                      <div className="com-price-box">
                        <p className="default-price">
                          {selectCoupon?.normalPrice}
                        </p>
                        <p className="price-text">Normal Price</p>
                      </div>
                      <span className="price-line"></span>
                      <div className="com-price-box">
                        <p className="discount-amount">
                          {selectCoupon?.couponAmount}
                        </p>
                        <p className="price-text">
                          {selectCoupon?.overPriceDesc}
                        </p>
                      </div>
                    </div>
                    {/* 可用券展示 */}
                    <div className="available-coupon">
                      <CouponItem item={selectCoupon} readonly={true} />
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>

              {/* 优惠券中心展示 */}
              <div className="coupon-enter">
                <p className="coupon-tip">
                  You can use one of the following coupons or enter a coupon
                  code to apply a new coupon.
                </p>
                <div className="coupon-form">
                  <Input
                    key={currentCode}
                    size="middle"
                    placeholder="Coupon Code"
                    value={value}
                    onChange={onInputChange}
                  />
                  <Button
                    block
                    // disabled={isLastValue}
                    size="middle"
                    type="primary"
                    onClick={
                      !Type.isVoid(currentCode) ? removeCoupon : onApply
                    }>
                    {!Type.isVoid(currentCode) ? 'Remove' : 'Apply'}
                  </Button>
                  <Switch either={!Type.isVoid(currentCode)}>
                    <p className="coupon-applied">
                      Coupon code "{currentCode}
                      {`(${currentCoupon?.formatDiscount} OFF)`}" was applied.
                    </p>
                  </Switch>
                </div>
              </div>
            </Switch>

            <Content>
              {/* 订阅券/新用户券 */}
              <Switch either={location?.pathname !== routesPath.checkout}>
                <>
                  {subscribeCoupon && subscribeStatus === 0 ? (
                    <CouponReg onOpen={() => setOpen(false)} showSubscribe />
                  ) : (
                    <></>
                  )}
                  {/* {!isLogin ? (
                    <CouponReg onOpen={() => setOpen(false)} />
                  ) : (
                    <></>
                  )} */}
                </>
              </Switch>

              {/* 详情页与优惠券中心展示（不分模块）：优惠券列表*/}
              <Switch either={!Type.isEmpty(data)}>
                <div className="coupon-list">
                  {data?.map((coupon) => {
                    return (
                      <CouponItem
                        key={coupon.couponCode}
                        item={coupon}
                        readonly={readonly}
                        currentCode={currentCode}
                        clickChange={(code) => usingCoupon(code)}
                        couponStyle={+coupon.couponStyle}
                      />
                    )
                  })}
                </div>
                {/* 当可用券只有一张时，在详情页直接显示空白即可, 否则显示空白icon */}
                <Switch
                  either={
                    !readonly &&
                    (location?.pathname === routesPath.checkout ||
                      !(subscribeCoupon && subscribeStatus === 0))
                  }>
                  <Empty
                    isCoupon={true}
                    text="No Coupons Available"
                    Icon={<Icon src={couponSrc} size={230} />}
                  />
                </Switch>
              </Switch>
              {/* 详情页展示（分模块展示的）：失效优惠券 */}
              <Switch either={!Type.isEmpty(finishGrantCoupons)}>
                <>
                  <p className="unavailable-title">Unavailable Coupons</p>
                  <div className="coupon-list">
                    {finishGrantCoupons?.map((coupon) => {
                      return (
                        <CouponItem
                          key={coupon.couponCode}
                          item={coupon}
                          readonly={readonly}
                          currentCode={currentCode}
                          clickChange={(code) => usingCoupon(code)}
                          couponStyle={5}
                        />
                      )
                    })}
                  </div>
                </>
              </Switch>
            </Content>
          </Layout>
        </Container>
      }
      closable
    />
  )
}

export default Index
